export default "__VITE_ASSET__a3776c35__"